import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useAppModal from 'hooks/useAppModal';
import { useNavigate } from 'react-router-dom';
import ScheduledMessagesRescheduleModal from './ScheduledMessagesRescheduleModal';
import { SCHEDULED_MESSAGES_RESCHEDULE_MODAL_ID } from './ScheduledMessagesRescheduleModal.constants';

const useScheduledMessagesRescheduleModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateBack = useCallback(() => {
    navigate('../..', { replace: true, relative: 'path' });
  }, [navigate]);

  const openRescheduleScheduledMessagesModal = ({
    scheduledMessageUid,
  }: {
    scheduledMessageUid: string;
  }) => {
    openModal({
      customContent: (
        <ScheduledMessagesRescheduleModal
          scheduledMessageUid={scheduledMessageUid}
          closeModal={navigateBack}
        />
      ),
      id: SCHEDULED_MESSAGES_RESCHEDULE_MODAL_ID,
      title: t('pageAutomations.scheduledMessages.modalReschedule.title'),
      closeOnHide: false,
      onHide: navigateBack,
    });
  };

  return { openRescheduleScheduledMessagesModal };
};

export default useScheduledMessagesRescheduleModal;
